/**
 * Where an event opens.
 *
 * The Plan calendar reads `?event=` and opens that event's side panel, fetching
 * it by id when it is outside the range the calendar has loaded — and routing a
 * sub-activity to `SubActivitySidePanel` rather than dressing it up as an event
 * (`DesktopCalendar`). It is the same consume-then-drop shape as its `?task_id=`
 * twin, which `SingleServiceHistory`'s "Check on calendar" already produces, so
 * a reload or a Back does not reopen what was closed.
 *
 * `/events` has a deep link of its own (`?event_id=`, honoured by `EventsPage`),
 * but the page has no entry in the nav and nothing in the app navigates to it
 * except notifications, so a search hit landing there strands the reader on a
 * list they cannot get back to. Plan is where the nav says events live.
 */

export const PLAN_EVENT_SEARCH_PARAM = 'event';

const PLAN_ROUTE = '/plan';

/** The Plan calendar, with the event itself opened on top of it. */
export const eventHref = (id: string): string => `${PLAN_ROUTE}?${PLAN_EVENT_SEARCH_PARAM}=${id}`;
